/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Previousslide1Inputs */

const he_common_previousslide1 = /** @type {(inputs: Common_Previousslide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שקופית קודמת`)
};

const en_common_previousslide1 = /** @type {(inputs: Common_Previousslide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Common_Previousslide1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_previousslide1 = /** @type {((inputs?: Common_Previousslide1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Previousslide1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_previousslide1(inputs)
	return en_common_previousslide1(inputs)
});
export { common_previousslide1 as "common_previousSlide" }